import { createContext, useContext } from 'react'

export const FileInputContext = createContext({})
export const useFileInputContext = () => useContext(FileInputContext)